<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
            <el-form-item label="商品类型">
                <el-select v-model="formInline.proType" clearable placeholder="商品类型" @change="">
                    <el-option
                            v-for="item in productTypes"
                            :key="item.proType"
                            :label="item.proType"
                            :value="item.proType">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="商品状态">
                <el-select v-model="formInline.proState" clearable placeholder="商品状态">
                    <el-option label="未上架" value="0"></el-option>
                    <el-option label="已上架" value="1"></el-option>
                    <el-option label="已下架" value="9"></el-option>
                    <el-option label="全部" value="-1"></el-option>
                    <!--<el-option-->
                    <!--v-for="item in proStates"-->
                    <!--:key="item.key"-->
                    <!--:label="item.value"-->
                    <!--:value="item.key">-->
                    <!--</el-option>-->
                </el-select>
            </el-form-item>
            <el-form-item label="69码">
                <el-input v-model="formInline.barCode" placeholder="69码"></el-input>
            </el-form-item>
            <el-form-item label="商品名称">
                <el-input v-model="formInline.proName" placeholder="商品名称"></el-input>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="getList">查询</el-button>
                <el-button type="success" @click="handleEdit({proId:0})">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="productList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column label="产品图片">
                <template slot-scope="scope">
                    <img :src="scope.row.listTemplateFile" width="60" height="60" class="head_pic"/>
                </template>
            </el-table-column>
            <el-table-column prop="proId" label="商品信息">
                <template slot-scope="scope">
                    <p>{{scope.row.proName}}</p>
                    <p>69码:{{scope.row.barCode}}</p>
                    <p>产品编码:{{scope.row.proCode}}</p>
                    <div>
                        <span>运输方式:</span>
                        <span v-if="scope.row.transportType==1">冷链</span>
                        <span v-else-if="scope.row.transportType==2">普快</span>
                        <span v-else-if="scope.row.transportType==3">虚拟商品不配送</span>
                    </div>
                </template>
            </el-table-column>
            <!--<el-table-column prop="barCode" label="69码"></el-table-column>-->
            <!--<el-table-column prop="proName" label="产品名称"></el-table-column>-->

            <el-table-column prop="proPrice" label="产品价格"></el-table-column>
            <el-table-column label="状态/显示">
                <template slot-scope="scope">
                    <div>
                        <span v-if="scope.row.proState==0">未上架</span>
                        <span v-else-if="scope.row.proState==1">已上架</span>
                        <span v-else-if="scope.row.proState==9">已下架</span>
                    </div>
                    <div>
                        <span v-if="scope.row.showState==0">不显示</span>
                        <span v-else-if="scope.row.showState==1">显示</span>
                    </div>
                </template>
            </el-table-column>
            <!--<el-table-column label="显示">-->
            <!--<template slot-scope="scope">-->

            <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="proDw" label="单位/规格">
                <template slot-scope="scope">
                    <p>单位:{{scope.row.proDw}}</p>
                    <p>规格:{{scope.row.proSpec}}</p>
                </template>
            </el-table-column>
            <!--<el-table-column prop="proSpec" label="规格"></el-table-column>-->
            <el-table-column prop="createTime" label="创建时间"></el-table-column>
            <el-table-column label="操作" fixed="right" width="250">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="success" size="mini" v-show="scope.row.proState==1"
                                   @click="sendToSiYu(scope.row)">同步私域

                        </el-button>
                        <el-button type="info" size="mini" @click="handlePreActive(scope.row)">预览</el-button>
                        <el-button type="warning" size="mini" @click="handleCheckUse(scope.row)">查询用途</el-button>
                        <el-button type="danger" v-show="false" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalRecord">
            </el-pagination>
        </div>
        <el-dialog title="预览" :visible.sync="showPreviewDialog" v-if="showPreviewDialog" width="50%">
            <Preview :linkType="this.linkType" :activeType="this.activeType" :params="this.params"></Preview>
        </el-dialog>
        <productCheckUse ref="productCheck"/>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getProductType, getProductList, delProduct, getProduct, addProduct, saveMediatApi} from '../../api/api'
    import selectPicComponents from '@/components/selectPic';
    import Preview from "../../components/Preview";
    import productCheckUse from "../../components/productCheckUse";
    //定义组件
    export default{
        data(){
            return {
                linkType: 4,
                activeType: -1,
                params: {},
                showPreviewDialog: false,
                loading: true,
                selectValue: '',
                dialogFormVisible: false,
                mediaEntity: {
                    type: 4,
                    itemId: '',
                    mediaType: 3
                },
                formInline: {
                    "proName": this.$route.query.proName || "",
                    "proType": "",
                    "proState": "1",
                    "barCode": "",
                    currentPage: parseInt(this.$route.params.id) || 1,
                    recordsTotal: 0,
                    pageSize: 10,
                }
            }
        },
        components: {
            selectPicComponents,
            Preview, productCheckUse
        },
        computed: {
            productList: function () {
                return this.$store.getters.getPro.list
            },
            totalRecord: function () {
                return this.$store.getters.getPro.total
            },
            productTypes: function () {
                return this.$store.getters.getProductType
            }
        },
        //挂载时候执行
        mounted(){
            //获取查询条件下拉列表
            this.$store.dispatch('initProductType')
            //初始化首页数据
            this.getList();
        },
        methods: {
            //定义查询方法
            getList(){
                this.loading = true;
                let _this = this;
                this.$store.dispatch('initProList', this.formInline).then(function (res) {
                    _this.loading = false;
                })
            },
            productTypesChange(){

            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                console.log(val)
                this.$router.push({path: '/productlist/:id', name: 'ProductList', params: {id: val}});
                this.getList();
            },
            handleEdit(row){
                this.$router.push({
                    path: '/productlist/detail/:id',
                    name: 'ProductDetail',
                    params: {id: row.proId},
                    query: {proId: row.proId, picType: '', picFrom: 'noReturn'}
                })
            },
            handleDel(row){
                this.$confirm('删除商品, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delProduct({proId: row.proId}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            sendToSiYu(row){
                this.mediaEntity.itemId = row.proId
                saveMediatApi(this.mediaEntity).then((res) => {
                    if (res.data.status == 200) {
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        //this.getList();
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            },
            handlePic(row){
                let routerL = '/' + this.$route.path.split('/')[1];
                this.$router.push({path: routerL + '/picture/' + row.proId, query: {picType: '', picFrom: 'noReturn'}})
            },
            handlePreActive(row){
                //this.activeType=row.activeType;
                this.params = {productId: row.proId, productType: 4};
                this.showPreviewDialog = true;
            },
            handleCheckUse(row){
                console.log(row)
                this.$refs.productCheck.openProductUse(row)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/sales/productList.vue